import 'cross-fetch/polyfill';
import { DECRYPT } from '@engine/actions/action-types';
/**
 * Action Creators for Decrypt field
 */

export var decryptFail = function decryptFail(field) {
  return {
    type: DECRYPT(field).decryptFail
  };
};
export var receivedDecryptedField = function receivedDecryptedField(data, field) {
  return {
    type: DECRYPT(field).fieldDecrypted,
    data: data
  };
};
export function decryptField(url, field) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';
  return function (dispatch) {
    return fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': window.CSRF
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(receivedDecryptedField(json, field));
    })["catch"](function () {
      return dispatch(decryptFail(field));
    });
  };
}